import React from 'react';

import { Icon } from '@ontruck/orc';

const StripeIcon = () => (
  <>
    <Icon className="icon" glyph="shield" size="16px" />
    <Icon
      className="icon"
      glyph="powered_by_stripe"
      size="40px"
      width="110px"
    />
  </>
);

StripeIcon.propTypes = {};

StripeIcon.defaultProps = {};

export default StripeIcon;
